import React, { useState } from 'react';
import {
	ArticleWrapper,
	CarouselButton,
	CarouselContainer,
	CarouselContent,
	CarouselWrapper,
} from './ArticleCarousel.styles';
import ArticleCard from '../ArticleCard/ArticleCard';

const ArticleCarousel = ({ articles }) => {
	const [currentIndex, setCurrentIndex] = useState(0);
	const articlesPerPage = 6;

	const handlePrevClick = () => {
		if (currentIndex > 0) {
			setCurrentIndex(currentIndex - articlesPerPage);
		}
	};

	const handleNextClick = () => {
		if (currentIndex + articlesPerPage < articles.length) {
			setCurrentIndex(currentIndex + articlesPerPage);
		}
	};

	const displayedArticles = articles.slice(
		currentIndex,
		currentIndex + articlesPerPage
	);

	return (
		<CarouselWrapper>
			<CarouselContainer>
				<CarouselContent key={currentIndex}>
					{displayedArticles.map((article, index) => (
						<ArticleWrapper key={index}>
							<ArticleCard {...article} />
						</ArticleWrapper>
					))}
				</CarouselContent>
				{articles.length > 0 && (
					<>
						<CarouselButton
							left
							onClick={handlePrevClick}
							disabled={currentIndex === 0}
						>
							❮
						</CarouselButton>
						<CarouselButton
							onClick={handleNextClick}
							disabled={currentIndex >= articles.length - articlesPerPage}
						>
							❯
						</CarouselButton>
					</>
				)}
			</CarouselContainer>
		</CarouselWrapper>
	);
};

export default ArticleCarousel;
